module.exports = __webpack_public_path__ + "static/img/ico_flower.18f8cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/ico_flower.png
// module id = R2he
// module chunks = 0